<template>
  <div class="page-wrapper">
    <section class="flex-cc dir-col flex-auto container">
      <h1 class="mb-s">找不到頁面</h1>
      <p class="mb-m">不好意思，找不到您搜尋的頁面......要重新尋找嗎？</p>
      <Button :style="{padding: 0}">
        <router-link
          to="/"
          :style="{
            display: 'inline-block',
            padding: '6px 15px'
          }"
          v-text="'回首頁'"
        />
      </Button>
    </section>
  </div>
</template>

<script>
  import { Button } from 'iview';

  export default {
    components: { Button }
  };
</script>
